import React from 'react';

import { Badge, Button, Typography } from '@mui/material';
import { Box } from '@mui/system';

import styles from './styles';

export interface ISegmentTab<T> {
  key: T;
  label: string;
  count: number;
}

interface IActiveUsersSegments<T> {
  tabs: Array<ISegmentTab<T>>;
  selected: T;
  showCount: boolean;
  onSelect: (key: T) => () => void;
}

const ActiveUsersSegments = <T extends string>({
  tabs,
  selected,
  showCount,
  onSelect,
}: IActiveUsersSegments<T>) =>
    (
      <Box sx={styles.segment}>
        {tabs.map(({ key, label, count }) => {
          const isActive = key === selected;
          const showBadge = showCount && count > 0;

          const text = (
            <Typography
              sx={[
                styles.text,
                styles.segmentButtons,
                isActive ? styles.activeText : styles.inActive,
              ]}
            >
              {label}
            </Typography>
          );

          return (
            <Button
              key={key}
              fullWidth
              variant="text"
              sx={[
                styles.segmentButtons,
                isActive ? styles.active : styles.inActive,
              ]}
              onClick={onSelect(key)}
            >
              {showBadge ? (
                <Badge badgeContent={count} color="error" sx={styles.badge}>
                  {text}
                </Badge>
              ) : (
                text
              )}
            </Button>
          );
        })}
      </Box>
    );

export default ActiveUsersSegments;
